  export const groupProductsIntoCategory = (datalist, filtername, listType?) => {
    let end_end_services_list = [];
    datalist = processResponse(datalist, listType);
    datalist.forEach(element => {
      let aa = element.category ? element.category.split(": ") : [];
      let end_end_services_details = {}
      Object.entries(element).forEach(item => {
        end_end_services_details[item[0]] = item[1]
      });

      if (!filtername) {
        end_end_services_details['category_name'] = aa[1] ? aa[1] : element.product_id
      }
      end_end_services_details['quantity'] = 1
      end_end_services_details['checked'] = false
      end_end_services_list.push(end_end_services_details)
    });
    let end_end_groups = {};
    if (filtername) {
      end_end_groups["All"] = end_end_services_list;
    } else {
      end_end_services_list.forEach((employee) => {
        let { category_name } = employee;
        let productlist = {}
        if (!end_end_groups[category_name]) {

          end_end_groups[category_name] = [];
        }
        productlist['product'] = employee
        end_end_groups[category_name].push(employee);
      });
    }
    // return end_end_groups;
    let productList = {}
    Object.entries(end_end_groups).forEach(element => {
      productList[element[0]] = end_end_groups[element[0]]

      Object.entries(productList[element[0]]).forEach(item => {
        item[1]['cost'] = item[1]['IRP'] ? parseFloat(item[1]['IRP']) * parseInt(item[1]['quantity']) : 0;
        item[1]['list_price'] = item[1]['default_list_price'] = item[1]['cost'];
      });
      productList[element[0]] = productList[element[0]].filter(item => 'list_price' in item && item.list_price !== '');
    });
    return productList
  }

  const processResponse = (respData, listType) => {
    let output = respData.reduce((acc, curr) => {
      let existingItem = acc.find(item => item.id === curr.id && item.product_id === curr.product_id);
      const prodKit = {
        product_kit_code: curr.product_code,
        product_kit_description: curr.product_description,
        product_kit_quantity: curr.quantity,
        percentage : curr.percentage ? curr.percentage : 0
      }
      // if listType is das_items then add more attributes to prodKit
      if (listType === 'das_items') {
        prodKit['oem'] = curr.oem;
        prodKit['connector'] = curr.connector;
        prodKit['environment_rating'] = curr.environment_rating;
        prodKit['tech_supported'] = curr.tech_supported;
        prodKit['freq_supported'] = curr.freq_supported;
      }
      if (existingItem) {
        existingItem.product_kits.push(prodKit);
      } else {
        acc.push({
          id: curr.id,
          product_id: curr.product_id,
          quantity: curr.quantity,
          product_description: curr.sales_kit_description ? curr.sales_kit_description : curr.product_description,
          product_code: curr.sales_kit_id ? curr.sales_kit_id : curr.product_code,
          status: curr.status,
          product_kits: [prodKit],
          memory_capacity: curr.memory_capacity ? curr.memory_capacity : '',
          pod_capacity: curr.pod_capacity ? curr.pod_capacity : '',
          storage_capacity: curr.storage_capacity ? curr.storage_capacity : '',
          vcpu_capacity: curr.vcpu_capacity ? curr.vcpu_capacity : '',
          IRP: curr.IRP,
          product_type_id: curr?.product_type_id ? curr?.product_type_id : '',
        });
      }
      return acc;
    }, []);
    return output;
  }